export const PublicWebUrl = {
  survey: '/survey',
  preview: '/preview',
  preview_form_generator: '/preview/form-generator',
  main_app: '/main-app/:account',
};
